/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

function notifyUser(message: string): void { /* document why this function 'notifyUser' is empty */  }

@Injectable({ providedIn: 'root' })
export class HandleUnrecoverableStateService {

    updates = inject(SwUpdate);

    constructor() {
        this.updates.unrecoverable.subscribe(event => {
            notifyUser('An error occurred that we cannot recover from:\n' + event.reason + '\n\nPlease reload the page.');
        });
    }
}
